<form #form="ngForm" class="container-form with-nav-tabs" novalidate>
    <!--Options-->
    <div class="row container-form-options">
        <div class="col-12">
            <button type="button" class="btn btn-success mr-2" (click)="save()" id="btnSave">
                <i class="fas fa-check" aria-hidden="true"></i> Salvar
            </button>
              <button type="button" class="btn btn-light" (click)="cancel()">
                <i class="fas fa-undo" aria-hidden="true"></i> Cancelar
            </button>
        </div>
    </div>

    <!--Content-->
    <div class="row container-form-content" *ngIf="entity">
        <div class="col-12 container-navs">
            <ul class="nav nav-tabs">
                <li class="nav-item">
                    <a class="nav-link active" data-target="#tabPrincipal" data-toggle="tab">Principal</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" data-target="#tabPrazos" data-toggle="tab">Prazos</a>
                </li>
            </ul>
            <div class="tab-content">
                <!-- Principal -->
                <div class="tab-pane active" id="tabPrincipal">
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="codigoIntegracaoErp" class="col-form-label">Código ERP</label>
                            <input type="text" class="form-control" [(ngModel)]="entity.codigoIntegracaoErp" id="codigoIntegracaoErp" name="codigoIntegracaoErp"
                                #codigoIntegracaoErp="ngModel" required="required" [autofocus]="true">
                            <p style="margin-bottom:0px;" class="form-text text-muted form-text-codigo-integracao">Código da condição no seu sistema ERP</p>
                            <sgt-form-control-error
                                *ngIf="codigoIntegracaoErp.errors && codigoIntegracaoErp.errors.required && codigoIntegracaoErp.dirty"
                                msgError="O Código ERP é obrigatório">
                            </sgt-form-control-error>
                        </div>
                        <div class="form-group col-12 col-md-3">
                            <label for="situacao" class="col-form-label">Situação</label>
                            <select class="form-control" name="situacao" id="situacao"
                                [ngModel]="entity.situacao || ''" (ngModelChange)="entity.situacao = $event ? $event : null"
                                #situacao="ngModel" required="required">
                                <option value="">Selecione a situação...</option>
                                <option *ngFor="let situacao of situacoes" [ngValue]="situacao.id">{{situacao.nome}}</option>
                            </select>
                            <sgt-form-control-error
                                *ngIf="situacao.errors && situacao.errors.required && situacao.dirty"
                                msgError="A situação é obrigatória">
                            </sgt-form-control-error>
                        </div>                         
                    </div>
                    <div class="row">
                        <div class="form-group col-12 col-md">
                            <label for="tipo" class="col-form-label">Tipo de Pagamento</label>
                            <select class="form-control" name="tipo" id="tipo"
                                [ngModel]="entity.tipo || ''" (ngModelChange)="entity.tipo = $event ? $event : null"
                                #tipo="ngModel" required="required">
                                <option value="">Selecione o tipo...</option>
                                <option *ngFor="let tipo of tipos" [ngValue]="tipo.id">{{tipo.nome}}</option>
                            </select>
                            <sgt-form-control-error
                                *ngIf="tipo.errors && tipo.errors.required && tipo.dirty"
                                msgError="O tipo de pagamento é obrigatório">
                            </sgt-form-control-error>
                        </div>
                        <div class="form-group col-12 col-md">
                            <label for="formaPagamento" class="col-form-label">Forma de Pagamento Padrão</label>
                            <select class="form-control" name="formaPagamento" id="formaPagamento"
                                [ngModel]="entity.idFormaPagamento || ''" (ngModelChange)="entity.idFormaPagamento = $event ? $event : null"
                                #formaPagamento="ngModel">
                                <option value="">Nenhuma forma de pagamento</option>
                                <option *ngFor="let formaPagamento of formasPagamentos" [ngValue]="formaPagamento.id">{{formaPagamento.nome}}</option>
                            </select>
                            <p class="form-text text-muted form-text-codigo-integracao">Forma de pagamento padrão utilizada por esta condição de pagamento</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12">
                            <label for="nome" class="col-form-label">Nome</label>
                            <input type="text" class="form-control " [(ngModel)]="entity.nome" name="nome" id="nome"
                                #nome="ngModel" required="required" maxlength="255">
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.required && nome.dirty"
                                msgError="O nome é obrigatório">
                            </sgt-form-control-error>
                            <sgt-form-control-error
                                *ngIf="nome.errors && nome.errors.maxlength"
                                msgError="O nome deve ter no máximo 255 caracteres">
                            </sgt-form-control-error>
                        </div>
                    </div>
                    <div class="row">
                        <div class="form-group col-12 col-md-3">
                            <label for="custoFinanceiro" class="col-form-label">Custo Financeiro</label>
                            <div class="input-group">
                                <sgt-decimal [(ngModel)]="entity.percCustoFinanceiro" name="percCustoFinanceiro" id="percCustoFinanceiro"
                                    #percCustoFinanceiro="ngModel" [ngControl]="percCustoFinanceiro">
                                </sgt-decimal>
                                <div class="input-group-append">
                                    <span class="input-group-text">%</span>
                                </div>                                
                            </div>
                            <sgt-form-control-error
                                *ngIf="percCustoFinanceiro.errors && percCustoFinanceiro.errors.decimalInvalid"
                                msgError="Custo inválido">
                            </sgt-form-control-error>
                        </div>
                    </div>
                </div>
                <!-- End Principal -->

                <!-- Prazos -->
                <div class="tab-pane" id="tabPrazos">
                    <div class="row">
                        <div class="form-group col-12 col-md-4">
                            <label for="multiplo" class="col-form-label">Multiplo</label>
                            <div class="input-group">
                                <input type="number" class="form-control" [(ngModel)]="entity.multiplo" id="multiplo" name="multiplo">
                                <div class="input-group-append">
                                    <span class="input-group-text">Dia(s)</span>
                                </div>                                
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="prazoInicial" class="col-form-label">Prazo Inicial</label>
                            <div class="input-group">
                                <input type="number" class="form-control" [(ngModel)]="entity.prazoInicial" id="prazoInicial" name="prazoInicial">
                                <div class="input-group-append">
                                    <span class="input-group-text">Dia(s)</span>
                                </div>
                            </div>
                        </div>
                        <div class="form-group col-12 col-md-4">
                            <label for="quantidadeParcelas" class="col-form-label">Qtd. de Parcelas</label>
                            <input type="number" class="form-control" [(ngModel)]="entity.quantidadeParcelas" id="quantidadeParcelas" name="quantidadeParcelas">
                        </div>
                    </div>
                    <sgt-condicao-pagamento-prazo
                        [entities]="entity.prazos"
                        [(prazoMedio)]="entity.prazoMedio"
                        #prazoCadastro>
                    </sgt-condicao-pagamento-prazo>
                </div>
                <!-- End Prazos -->
            </div>
        </div>
    </div>
</form>
